import React from 'react';
import PropTypes from 'prop-types';

import BEM from '../../Utilities/BEM/index.jsx';


class CMSContent extends React.Component {
  render() {
    var classNames = BEM.classString('sbm-cms-content', this.props.variants);

    if (this.props.content) {
      var innerHtml = {
        __html: this.props.content
      };

      return <div className={classNames} dangerouslySetInnerHTML={innerHtml} />;
    } else {
      return <div className={classNames}>{this.props.children}</div>;
    }
  }
}


CMSContent.propTypes = {
  content: PropTypes.string,
  variants: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ])
};


export default CMSContent;

